/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { FormControlLabel, Switch, SwitchProps } from "@mui/material";
import { FC, useState } from "react";

interface LabeledSwitchProps extends SwitchProps {
  label?: string;
}
export const LabeledSwitch: FC<LabeledSwitchProps> = ({
  label,
  checked,
  disabled,
  onChange,
}) => {
  const [checkedFlag, setCheckedFlag] = useState(checked);
  return (
    <FormControlLabel
      control={
        <Switch
          disabled={disabled}
          checked={checkedFlag}
          onChange={(event) => {
            setCheckedFlag(event.target.checked);
            onChange?.(event, event.target.checked);
          }}
          sx={{ m: 1 }}
          defaultChecked
        />
      }
      label={label}
    />
  );
};
